module.exports = __webpack_public_path__ + "media/answer.d677bc8b.aac";